import React from 'react';
import abhishekImage from '../images/abhishek.jpeg';
import harshImage from '../images/harsh.jpeg';
import mohitImage from '../images/mohit.jpeg';

const About = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header with Logo */}
      <nav className="fixed top-0 w-full z-50 backdrop-blur-md bg-black/20 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <a href="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
              <img src="/logo.png" alt="Slyder Logo" className="h-10 w-10" />
              <span className="text-2xl font-bold text-white">Slyder.</span>
            </a>
          </div>
        </div>
      </nav>

      <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">About Slyder</h1>

          <div className="space-y-6 text-gray-300">
            <section>
              <p className="text-lg leading-relaxed">
                Slyder is a next-generation AI dating simulator and assistant that redefines how you experience companionship and connection. Whether you're looking to chat, call, or build meaningful relationships, our AI companions are here for you.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-white">Core Features</h2>
              <ul className="list-disc pl-6 space-y-3">
                <li><strong>Chat with AI Companions:</strong> Engage in natural, flowing text conversations with virtual AI-powered companions who understand and respond to you.</li>
                <li><strong>Voice Calls:</strong> Take your connection to the next level with real-time voice calling for a more immersive experience.</li>
                <li><strong>Swipe & Match:</strong> Discover companions through our intuitive swipe interface, just like your favorite dating apps.</li>
                <li><strong>Relationship Progression:</strong> Watch your relationships evolve as companions grow and adapt based on your engagement.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-white">Dating Assistant</h2>
              <p className="text-lg leading-relaxed">
                Beyond simulation, Slyder also offers AI-powered dating coaching features including profile analysis and chat reply suggestions to help you level up your real-world dating game.
              </p>
            </section>

            <section>
              <p className="text-lg leading-relaxed">
                Our mission is to empower individuals to build better connections by leveraging AI to facilitate more authentic and thoughtful interactions. Slyder isn't just another dating app; it's your companion for the modern dating journey.
              </p>
            </section>

            <section className="mt-12">
              <h2 className="text-2xl font-semibold mb-6 text-white">Our Founders</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                {/* Abhishek */}
                <a
                  href="https://www.linkedin.com/in/abhishekrudrapaul/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                >
                  <div className="backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:scale-105">
                    <div className="flex flex-col items-center text-center">
                      <img
                        src={abhishekImage}
                        alt="Abhishek Rudra Paul"
                        className="w-32 h-32 rounded-full object-cover mb-4 border-2 border-purple-500"
                      />
                      <h3 className="text-xl font-semibold text-white mb-2">Abhishek Rudra Paul</h3>
                      <div className="flex items-center text-purple-400 group-hover:text-purple-300 transition-colors">
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                        <span className="text-sm">View LinkedIn</span>
                      </div>
                    </div>
                  </div>
                </a>

                {/* Mohit */}
                <a
                  href="https://www.linkedin.com/in/mohit-hingonia-981a541ba/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                >
                  <div className="backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:scale-105">
                    <div className="flex flex-col items-center text-center">
                      <img
                        src={mohitImage}
                        alt="Mohit Hingonia"
                        className="w-32 h-32 rounded-full object-cover mb-4 border-2 border-purple-500"
                      />
                      <h3 className="text-xl font-semibold text-white mb-2">Mohit Hingonia</h3>
                      <div className="flex items-center text-purple-400 group-hover:text-purple-300 transition-colors">
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                        <span className="text-sm">View LinkedIn</span>
                      </div>
                    </div>
                  </div>
                </a>

                {/* Harsh */}
                <a
                  href="https://www.linkedin.com/in/imguptaharsh/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                >
                  <div className="backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:scale-105">
                    <div className="flex flex-col items-center text-center">
                      <img
                        src={harshImage}
                        alt="Harsh Gupta"
                        className="w-32 h-32 rounded-full object-cover mb-4 border-2 border-purple-500"
                      />
                      <h3 className="text-xl font-semibold text-white mb-2">Harsh Gupta</h3>
                      <div className="flex items-center text-purple-400 group-hover:text-purple-300 transition-colors">
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                        <span className="text-sm">View LinkedIn</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative py-16 border-t border-white/10">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="text-3xl font-bold mb-4">Slyder.</div>
              <p className="text-gray-400 mb-6 max-w-md">
                AI-powered dating simulator and assistant. Chat, call, and build
                meaningful connections with AI companions.
              </p>
              <div className="flex space-x-4">
                <a href="https://www.instagram.com/slyder.ai/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-gradient-to-tr hover:from-pink-500 hover:to-yellow-500 transition-colors cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-pink-400">
                    <rect width="20" height="20" x="2" y="2" rx="6" fill="none" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="12" cy="12" r="5" fill="none" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="17" cy="7" r="1.2" fill="currentColor"/>
                  </svg>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="/#features" className="hover:text-white transition-colors">Features</a></li>
                <li><a href="/#testimonials" className="hover:text-white transition-colors">Success Stories</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a></li>
                <li><a href="/terms-and-conditions" className="hover:text-white transition-colors">Terms of Service</a></li>
                <li><a href="/refund-policy" className="hover:text-white transition-colors">Refund Policy</a></li>
                <li><a href="/delete-account" className="hover:text-white transition-colors">Delete Account</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 mt-12 pt-8 text-center text-gray-400">
            <p>&copy; 2025 Slyder. All rights reserved. Built with ❤️ for modern dating success.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;
